<div class="dialog-header flex justify-content-between align-items-center gap-2">
  <h2>Aprobare borderou</h2>
  <p-button
    mat-dialog-close
    size="small"
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content class="pb-2">
  <p>
    Sunteți pe cale să acceptați un borderou
    @if (preInvoice.period.start && preInvoice.period.end) {
      din perioada
      <b>
        {{ preInvoice.period.start | date: "dd/MM/yyyy" }} -
        {{ preInvoice.period.end | date: "dd/MM/yyyy" }}
      </b>
    }
    în valoare de
    <b>{{ preInvoice.grossAmount | currency: "RON" }}</b>.
  </p>
  <p>Zona aferentă borderoului: <b>{{ preInvoice.zone.name }}</b></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="flex align-items-center gap-2">
    <button
      pButton
      label="Aprobă"
      severity="success"
      icon="pi pi-check"
      iconPos="left"
      size="small"
      (click)="approve()"
    ></button>

    <button
      pButton
      mat-dialog-close
      label="Închide"
      size="small"
      [text]="true"
    ></button>
  </div>
</mat-dialog-actions>
@if (loading()) {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}